// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollHint-module--scroll--3XmWD","sdb":"ScrollHint-module--sdb--WyPdX"};